import { render, staticRenderFns } from "./data31.vue?vue&type=template&id=d0538d50&scoped=true"
import script from "./data31.vue?vue&type=script&lang=js"
export * from "./data31.vue?vue&type=script&lang=js"
import style1 from "./data31.vue?vue&type=style&index=1&id=d0538d50&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0538d50",
  null
  
)

export default component.exports